/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/Form/fields
 * @desc Form Fields for ExperimentWorkflow
 */

import { FieldType } from 'labstep-web/constants/form';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type { Group } from 'labstep-web/models/group.model';
import rules from 'labstep-web/services/validation/rules';

export const fieldExperimentWorkflowName: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  name: 'name',
  validation: rules.experiment_workflow.name,
  placeholder: 'Give your experiment a name',
  header: true,
};

export const fieldExperimentWorkflowNameWithLabel: FieldWithoutActionProps =
  {
    fieldType: FieldType.Text,
    name: 'name',
    fieldLabel: 'Name',
    validation: rules.experiment_workflow.name,
    placeholder: 'Give your experiment a name',
    header: true,
  };

export const fieldExperimentWorkflowPlannedAt: FieldWithoutActionProps =
  {
    name: 'planned_at',
    fieldLabel: 'Planned Dates',
    validation: rules.experiment_workflow.planned_at,
    fieldType: FieldType.DateTimePicker,
    elementProps: {
      dateTimePickerOptions: {
        mode: 'range',
        rangeNames: ['start_planned_at', 'end_planned_at'],
      },
    },
  };

export const getFieldExperimentWorkflowTemplate = (
  activeGroupId: Group['id'],
): FieldWithoutActionProps => {
  return {
    name: 'source',
    fieldLabel: 'Template',
    validation: rules.experiment_workflow.template,
    fieldType: FieldType.SearchSelect,
    elementProps: {
      entityName: ExperimentWorkflow.entityName,
      placeholder: 'Search templates...',
      params: { is_template: true, group_id: activeGroupId },
    },
  };
};
